
import { getTenant } from '@/api/admin/tenant'

let validateTenantCode = (rule, value, callback) => {
  getTenant(value).then(response => {
     callback()
    let result = response.data.data
    if (result !== null) {
      callback(new Error('租户代码已经存在'))
    } else {
      callback()
    }
  })
}
let validateTenantName = (rule, value, callback) => {
  getTenant(value).then(response => {
     callback()
    let result = response.data.data
    if (result !== null) {
      callback(new Error('租户名称已经存在'))
    } else {
      callback()
    }
  })
}

export const tableOption = {
  "border": true,
  "index": true,
  "stripe": true,
  "indexLabel": "序号",
  "menuAlign": "center",
  "align": "center",
  "editBtn": false,
  "delBtn": false,
  "addBtn": false,
  'refreshBtn': false,
  'columnBtn': false,
  'searchSize': 'mini',
  'searchBtn': false,
  "dic": [],
  "column": [
    {
      label: '主键',
      prop: 'id',
      hide: true,
      editVisdiplay: false,
      addVisdiplay: false
    },
    {
      label: '租户代码',
      prop: 'corpCode',
      span: 24,
      rules: [{
        required: true,
        message: '请输入租户代码'
      },
        {
          min: 3,
          max: 20,
          message: '长度在 4 到 20 个字符',
          trigger: 'blur'
        },
        { validator: validateTenantCode, trigger: 'blur' }
      ]
    },
    {
      label: '租户名称',
      prop: 'corpName',
      span: 24,
      rules: [{
        required: true,
        message: '请输入租户名称'
      },
        {
          min: 3,
          max: 20,
          message: '长度在 4 到 20 个字符',
          trigger: 'blur'
        },
        { validator: validateTenantName, trigger: 'blur' }
      ]
    },
    {
      label: '创建者',
      prop: 'createBy'
    },
    {
      label: '创建时间',
      prop: 'createTime',
      type: 'timestamp',
      valueFormat:'yyyy-MM-dd HH:mm:ss',
      format:'yyyy-MM-dd hh:mm:ss'

    },
    {
      label: '更新时间',
      prop: 'updateTime',
      type: 'timestamp',
      valueFormat:'yyyy-MM-dd HH:mm:ss',
      format:'yyyy-MM-dd hh:mm:ss'
    }
  ]
}
